import { useFormDataContext } from "@totalenergiescode/mobility-business-rev-form-data/components";

import FormFieldRenderer from "@/components/FormData/lib/layout/Renderers/FormFieldRenderer";

const DefaultSummaryRenderer = () => {
  const { form, translator } = useFormDataContext();

  return (
    <>
      {form.steps
        .filter((step) => step.isRenderable())
        .filter((step) => step.hasAtLeastOneFieldToBeDisplayed())
        .map((step) => (
          <div key={`step-${step.number}`}>
            <h4>{`${translator.with(step)}`}</h4>

            {step.sections
              .filter((section) => section.mustBeDisplayed())
              .map((section) => (
                <div key={`section-${section.number}`}>
                  <h5>{`${translator.with(section)}`}</h5>

                  {section.subSections
                    .filter((subSection) => subSection.mustBeDisplayed())
                    .map((subSection) => (
                      <div key={`sub-section-${subSection.number}`}>
                        <h6>{`${translator.with(subSection)}`}</h6>

                        {subSection.rows.map((row) => (
                          <div key={`row-${row.number}`}>
                            {row.fields
                              .filter((field) => field.mustBeDisplayed())
                              .map((field) => (
                                <FormFieldRenderer
                                  key={field.id()}
                                  fieldId={field.id()}
                                  summary={true}
                                />
                              ))}
                          </div>
                        ))}
                      </div>
                    ))}
                </div>
              ))}
          </div>
        ))}
    </>
  );
};

export default DefaultSummaryRenderer;
